import * as React from 'react';
import SelectField from '../../common/form-controls/SelectField';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import { Environment } from '../../../models/enums/Environment';
import { authenticatedUser } from '../../../authentication/authModule';
import { UserRole } from '../../../models/enums/UserRole';

interface ServiceEnviornmentInputProps extends FieldHandler<string> { }

interface ServiceEnvironmentInputState {

}

export class ServiceEnviornmentInput extends React.Component<ServiceEnviornmentInputProps, ServiceEnvironmentInputState> {
    render() {
        return (
            <SelectField
                label="Services Environment"
                className="full-width"
                options={
                    [
                        { text: 'DEFAULT', value: 'DEFAULT' },
                        { text: 'LABLAN', value: 'LABLAN' },
                    ]
                }
                {...this.props}
            />
        );
    }
}